import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { CompanyManagementContentService } from '../../services/company-management-content.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-flight-promo-code',
    templateUrl: './flight-promo-code.component.html',
    styleUrls: ['./flight-promo-code.component.scss'],
    imports: [ReactiveFormsModule, FormsModule, MatFormField, MatLabel, MatInput, MatIcon, MatSuffix, MatSelect, MatOption, MatCheckbox, MatRadioGroup, MatRadioButton, MatButton]
})
export class FlightPromoCodeComponent implements OnInit, OnDestroy {
private destroy$ = new Subject<void>();
content:any;
constructor(private contentService:CompanyManagementContentService){

}
ngOnInit(){
  this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
    this.content = res;
  })
}
ngOnDestroy(){
  this.destroy$.next();
  this.destroy$.complete();
}
}
